import { Box, Text } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { SeV2QuestionDto, SupplierInformationDto } from "../../../autogen/bff-api";
import { TipTap } from "../../input/TipTap/TipTap";
import { AttachmentList } from "./AttachmentList";
import { formatDateTime, personName } from "./communicationUtils";

export const AnnouncementCard = ({
  eventId,
  announcement,
  originatingQuestions = [],
  buyerName,
}: {
  // Optional: absent when there is no originating event to scope attachment downloads to (contract-origin view).
  eventId?: string;
  announcement: SupplierInformationDto;
  originatingQuestions?: SeV2QuestionDto[];
  buyerName?: string;
}) => {
  const { t } = useTranslation();
  const buyerOnlyQuestions = announcement.question ? [] : originatingQuestions;
  const isPublishedAnswer = !!announcement.question || buyerOnlyQuestions.length > 0;
  return (
    <Box borderWidth="1px" borderColor="smBorder" rounded="lg" overflow="hidden" bg="smBackground">
      <Box px="4" py="3" borderBottomWidth="1px" borderColor="smBorder">
        {buyerName && (
          <Text fontSize="xs" fontWeight="semibold" color="smMuted" textTransform="uppercase" letterSpacing="wide">
            {t("Information from {{buyer}}", { buyer: buyerName })}
          </Text>
        )}
        <Text fontSize="md" fontWeight="semibold" color="smText">
          {announcement.title}
        </Text>
      </Box>

      {announcement.question && (
        <Box px="4" py="3">
          <Text fontSize="sm" fontWeight="semibold" color="smText" mb="1">
            {t("Question")}
          </Text>
          <TipTap content={announcement.question} editable={false} maxHeight="96" />
        </Box>
      )}

      {buyerOnlyQuestions.map((question) => (
        <Box key={question.id} px="4" py="3">
          <Text fontSize="sm" fontWeight="semibold" color="smText" mb="1">
            {t("Question")} · {personName(question.askedByPerson)} · {question.askedByOrgName}{" "}
            <Text as="span" fontWeight="normal" color="smMuted">
              · {t("not shown to tenderers")}
            </Text>
          </Text>
          <TipTap content={question.content} editable={false} maxHeight="96" />
        </Box>
      ))}

      {isPublishedAnswer ? (
        <Box px="4" py="4" borderTopWidth="1px" borderColor="smBorder" bg="smPrimarySofter">
          <Text fontSize="sm" fontWeight="semibold" color="smChipTealFg" mb="1">
            {t("Answer")}
          </Text>
          <TipTap content={announcement.content} editable={false} maxHeight="96" />
        </Box>
      ) : (
        <Box px="4" py="3">
          <TipTap content={announcement.content} editable={false} maxHeight="96" />
        </Box>
      )}

      <Box px="4" pt="0" pb="2">
        <AttachmentList eventId={eventId} attachments={announcement.attachments} />
      </Box>

      <Box px="4" py="3" borderTopWidth="1px" borderColor="smBorder">
        <Text fontSize="xs" color="smMuted">
          {personName(announcement.createdBy)} · {formatDateTime(announcement.createdAt)}
        </Text>
      </Box>
    </Box>
  );
};
